<template>
    <span>
        {{ modelValue.description }} <span class="badge badge-dark">{{ $filters.toQuantity(modelValue.hours) }} {{ $t('prepaidcard.hours') }}</span>  <span class="badge badge-light">{{ $filters.toCurrency(modelValue.price * modelValue.quantity) }}</span>
    </span>
</template>

<script>
export default {
    props: {
        modelValue: Object,
    },
};
</script>
